import type { FontWeight } from '../../types'
import {
  SbFontWeightBold,
  SbFontWeightMedium,
  SbFontWeightRegular,
} from './generated-tokens/ts/font-weight'

export const fontWeight: FontWeight = {
  regular: SbFontWeightRegular,
  medium: SbFontWeightMedium,
  bold: SbFontWeightBold,
}
